module.exports = __webpack_public_path__ + "img/settings.92c25f37.png";